import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '../components/core_link';
import { MParticleEvent } from '../elog/mparticle_types';
import { CTA } from '../elog/mparticle_tracker';
import { RCIcon } from '@reverbdotcom/cadence/components';
import { ArrowRightIcon } from '@phosphor-icons/react';

interface Props {
  href: string;
  text?: string;
  clickEvent?: MParticleEvent;
  'aria-describedby'?: string;
}

export function OverflowingRowAction(props: Props) {
  return (
    <CoreLink
      className="weight-bold fg-color-text-primary"
      to={props.href}
      clickEvent={props.clickEvent}
      interactionType={CTA}
      aria-describedby={props['aria-describedby']}
    >
      {props.text ? props.text : I18n.t('commons.seeMore')}
      <RCIcon icon={<ArrowRightIcon />} size="inline-prominent" spacing="left" />
    </CoreLink>
  );
}
